import enviro from 'enviro';
const MICROSOFT_DRIVE_APP_IDS = {
  QA: 35132221,
  PROD: 43904875
};
export const MICROSOFT_DRIVE_APP_ID = enviro.isQa() ? MICROSOFT_DRIVE_APP_IDS.QA : MICROSOFT_DRIVE_APP_IDS.PROD;
export const APP_FEATURE_IDS = {
  MANAGE_CONNECTIONS: 'manageConnections'
};